import { Box, Typography } from '@mui/material';
import Tooltip from './Tooltip';
import React from 'react';
import { formatAsDollars, formatAsThousands } from '../../utils/formatters';

const AllSavings = ({ min, max, format }) => (
  <>
    {format(max)}
    {min !== max && (
      <>
        {' to '}
        {format(min)}
      </>
    )}
  </>
);

const AllCost = ({ min, max, format }) => (
  <>
    {format(min)}
    {min !== max && (
      <>
        {' to '}
        {format(max)}
      </>
    )}
  </>
);

export default function CostSection({ label, costs, tooltip, children }) {
  return (
    <Box>
      <Typography variant="h3" fontWeight={600} mb={2}>
        {label} {tooltip && <Tooltip title={tooltip} />}
      </Typography>
      {costs.map(({ component_name, price_description, price_range, price_unit }, index) => {
        const [min, max] = price_range;
        const previous = costs[index - 1] || null;
        const format = price_unit === 'usd' ? formatAsDollars : formatAsThousands;
        return (
          <React.Fragment key={index}>
            {component_name !== previous?.component_name && (
              <Typography variant="h5" fontWeight={600} mt={2} mb={0.5}>
                {component_name}
              </Typography>
            )}
            <Box mb={0.5}>
              <Box display="flex" justifyContent="space-between" gap={1}>
                <Box>{price_description}</Box>
                <Box textAlign="right" whiteSpace="nowrap">
                  {min < 0 && max < 0 ? (
                    <AllSavings min={min} max={max} format={format} />
                  ) : (
                    <AllCost min={min} max={max} format={format} />
                  )}
                </Box>
              </Box>
            </Box>
          </React.Fragment>
        );
      })}
      {children}
    </Box>
  );
}
